module.exports = __webpack_public_path__ + "img/family-emptyState_Mobile.2e0f0645.svg";